import { render, staticRenderFns } from "./TypesTab.vue?vue&type=template&id=426a48bb&scoped=true&"
import script from "./TypesTab.vue?vue&type=script&lang=js&"
export * from "./TypesTab.vue?vue&type=script&lang=js&"
import style0 from "./TypesTab.vue?vue&type=style&index=0&id=426a48bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426a48bb",
  null
  
)

export default component.exports